import { ErrorOutline } from '@mui/icons-material'
import { Box } from '@mui/material'

type ErrorProps = {
  message?: string
}

/**
 * A region that failed to load (design system: EmptyState, failed variant).
 * It used to be a bare error icon in `Page center` — with no message, which
 * is how every caller uses it, it said nothing at all.
 */
export const ErrorDisplay = ({ message }: ErrorProps) => (
  <Box
    role="alert"
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center',
      gap: '8px',
      py: '32px',
      px: '24px',
      flex: 1,
    }}
  >
    <ErrorOutline sx={{ fontSize: 28, color: 'var(--state-failed)' }} />
    <Box sx={{ fontSize: 14, fontWeight: 700, color: 'var(--ink-700)' }}>
      Could not load this data
    </Box>
    <Box sx={{ fontSize: 12, color: 'var(--ink-500)', maxWidth: 360 }}>
      {message ?? 'Refresh the page to try again.'}
    </Box>
  </Box>
)
